import { Component, OnInit, ChangeDetectorRef, NgZone, HostListener } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
import * as _moment from 'moment';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { empty } from 'rxjs';
import { AntEnvService, AuthService, DataService } from '../../_services';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-location-setup',
  templateUrl: './location-setup.component.html',
  styleUrls: ['./location-setup.component.css'],
})
export class LocationSetUpComponent implements OnInit {
  client = '';
  public selectedMomentStart = new Date();
  public selectedMomentEnd = new Date();
  public selectedMoment = [new Date(), new Date()];
  tArea:any;

  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    public svcAuth: AuthService,
    public svcData: DataService,
    public svcAntEnv: AntEnvService,
    dateTimeAdapter: DateTimeAdapter<any>,
    private activatedRoute: ActivatedRoute
  ) { 
    
  }  
  pageData = {
    account: {     
    },
    cacheIndex: -1,
    cacheType:[],
    areas:[],
    viewMode: 'LIST',    
    autoRefresh: false,
    sensorSelected: 0,
    disabled: true,
  }
  area:any;
  rootArea:any;
  selectedSensor:any ="";
  x:any=0;
  y:any=0;
  camX:any=0;
  camY:any=0;
  ratio:any;
  resized:any;
  actualsize:any;

  ngOnInit() { 
    this.pageData.disabled = true;
    this.selectedSensor = "";
    this.x,this.y = 0;
    let areaId = this.activatedRoute.snapshot.params.areaId;
    //console.log(areaId);
    this.svcAntEnv.load().subscribe(res=>{
      if(res.client != null){
          this.client = res.client;
      }
    });
    this.svcData.areaDetail(areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.tArea = res.data;
    });
  }
  ngAfterViewInit(){
  }

 addRadio(rdo){
   this.selectedSensor = rdo;
   if(this.x != 0 && this.y != 0){
    this.pageData.disabled = false;
   }
 } 
 getPositionXY(evtArg){
   //console.log(evtArg)
  //  this.y = evtArg.pageY - 130;
  //  this.x = evtArg.pageX - 155;

  var imgElement = document.getElementById('imgFP');
  var imgCamElement = document.getElementById('imgCam');
  const rect = imgElement.getBoundingClientRect();
  const crect = imgCamElement.getBoundingClientRect();

  this.x = evtArg.clientX - rect.left;
  this.y = evtArg.clientY - rect.top;

  this.camY = this.y + crect.height;
  this.camX = this.x + crect.width/2;

  // if (evtArg.pageX || evtArg.pageY) { 
  //   this.x = evtArg.pageX;
  //   this.y = evtArg.pageY;
  // }
  // else { 
  //   this.x = evtArg.clientX + document.body.scrollLeft + document.documentElement.scrollLeft; 
  //   this.y = evtArg.clientY + document.body.scrollTop + document.documentElement.scrollTop; 
  // } 
  // this.x -= imgElement.offsetLeft;
  // this.y -= imgElement.offsetTop;
  
  if(this.selectedSensor != ""){
    this.pageData.disabled = false;
  }
}
  showAlert(msg){
    M.toast({html: msg});
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
  } 
  SaveLocationSetUp() {
    this.svcData.locationSetUp(this.tArea.areaId, this.selectedSensor, this.x, this.y).subscribe(res => {
      if (res.status != 'OK') {
        this.showAlert(res.message);
        return;
      }
      this.showAlert(res.message);
      this.ngOnInit();
    });
  }
}